import { Icon, IconProps } from "../";

export const TriangleLeftLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12L16 17.1962V6.80386L7 12ZM4.5 11.134C3.83333 11.5189 3.83333 12.4811 4.5 12.866L16.5 19.7942C17.1667 20.1791 18 19.698 18 18.9282V5.0718C18 4.302 17.1667 3.82088 16.5 4.20578L4.5 11.134Z"
      />
    </Icon>
  );
};
